!function () {
	// Vérifie que w3-drawer existe déjà
	const BaseDrawer = customElements.get("w3-drawer");

	if (!BaseDrawer) {
		console.warn("w3-drawer must be defined before defining w3-drawer-advice");
		return;
	}

	// Redéfinit uniquement w3-drawer-advice s'il n'existe pas encore
	if (!customElements.get("w3-drawer-advice")) {
		class DrawerAdvice extends BaseDrawer {
			constructor() {
				super();
			}

			connectedCallback() {
				super.connectedCallback();
				this.bindEventsListeners();
			}

			bindEventsListeners() {
				document.addEventListener("drawer:advice:init", () => {
					super.bindEvents();
				});
			}

			openDrawer(e) {
				if (!e?.target) return;

				this.Drawer.classList.add("drawer--loading");
				super.openDrawer();

				this.drawerMaincontent = this.querySelector(".drawer__main");

				let t = "";
				if (this.getAttribute("drawer-content")) {
					t = this.getAttribute("drawer-content");
				} else if (e.target.getAttribute("drawer-content")) {
					t = e.target.getAttribute("drawer-content");
				}

				if (t) this.fetchContent(t);
			}

			async fetchContent(url) {
				try {
					const res = await fetch(url);
					const html = await res.text();
					this.drawerMaincontent.innerHTML = html;
					this.Drawer.classList.remove("drawer--loading");
				} catch (err) {
					console.error(err);
				}
			}
		}

		customElements.define("w3-drawer-advice", DrawerAdvice);
	}
}();